import { render, staticRenderFns } from "./Teb.vue?vue&type=template&id=4dcafc2a"
import script from "./Teb.vue?vue&type=script&lang=js"
export * from "./Teb.vue?vue&type=script&lang=js"
import style0 from "./Teb.vue?vue&type=style&index=0&id=4dcafc2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports